import React from "react";
import { useTranslation } from "react-i18next";
import { TypographyWithInfoIcon } from "@components";

interface Props {
  comment?: string;
}

export const Note = ({ comment }: Props) => {
  const { t } = useTranslation();

  if (!comment) return null;
  const commentWithLabel = `${t(
    "domains.investments.investmentTable.notePrefix"
  )}: ${comment}`;

  return (
    <TypographyWithInfoIcon
      variant="caption2"
      color="textSecondary"
      tooltipText={commentWithLabel}
      hideIcon
      containerSx={{
        display: "inline-flex",
        alignItems: "center",
        maxWidth: 200,
        overflow: "hidden",
      }}
      sx={{
        display: "block",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        minWidth: 0,
      }}
    >
      {commentWithLabel}
    </TypographyWithInfoIcon>
  );
};
